<template>
  <div>
    <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
      <div class="card-header mt-4">
        <h1>Create Notification</h1>
        <hr />
        <form>
          <div class="row">
            <div class="col-md-12">
              <label for="Title">Title</label>
              <span class="error" v-if="!title && !isFieldRequired">* field required</span>
              <base-input
                alternative
                v-model="title"
                placeholder="Title"
                @input="onInputChanged()"
              />
            </div>
            <div class="col-md-12">
              <label for="Description">Description</label>
              <span class="error" v-if="!description && !isFieldRequired">* field required</span>
              <textarea
                class="form-control"
                rows="3"
                v-model="description"
                placeholder="Write your description ..."
                @input="onInputChanged()"
              ></textarea>
            </div>
            <div class="col-md-12 text-center">
              <base-button type="primary" class="btn-push" @click="onPushClicked()">Push</base-button>
            </div>
            <div class="col-md-12 text-center mt-3 mb-3" v-if="success && !title && !description">
              <span class="success">{{ success }}</span>
            </div>
            <div class="col-md-12 text-center mt-3 mb-3" v-if="error && !title && !description">
              <span class="failed">{{ error.message }}</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import { CREATE_NOTIFICATION } from '@/store/actions.type'

export default {
  data() {
    return {
      title: '',
      description: '',
      success: '',
      isFieldRequired: true
    }
  },
  methods: {
    onPushClicked() {
      if (this.title && this.description) {
        this.$store
          .dispatch(CREATE_NOTIFICATION, {
            title: this.title,
            description: this.description
          })
          .then(() => {
            this.title = ''
            this.description = ''
            this.success = 'Notification has been created !'
          })
      } else {
        this.isFieldRequired = false
      }
    },
    onInputChanged() {
      this.success = ''
      this.isFieldRequired = true
      this.$store.state.notification.error = null
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.notification.isLoading,
      error: state => state.notification.error
    })
  }
}
</script>
<style scoped>
.btn-push {
  margin-top: 3rem !important;
  margin-bottom: 1.5rem !important;
  border-radius: 20px !important;
  padding: 0.6rem 2rem !important;
}
.card-header hr {
  border-top: 1px solid rgba(225, 225, 225, 0.5) !important;
  margin-top: 0 !important;
}
.card-header {
  border-radius: 15px !important;
  box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.2),
    0 6px 20px 0 rgba(92, 92, 92, 0.19);
}

.success {
  color: #962100 !important;
  font-size: 18px;
}
.failed {
  color: #fb6340 !important;
  font-size: 18px;
}
</style>
